import { ACCOUNT_TYPES } from '../../../../app/appConstants';
import BinIcon from '../../../../components/icon/Icon';
import { SelectAccountToggle2Styled } from './styled/LiteTradeSelectAccountStyled';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import type { IAccountType } from '../../../../app/types/appActions.t';
import { MouseEventHandler } from 'react';
import classNames from 'classnames';


interface ILiteTradeSelectAccountToggleProps {
    variant?: string,
    onClick: MouseEventHandler<HTMLDivElement>,
    type: IAccountType,
    disabled?: boolean,
}

const LiteTradeSelectAccountToggle2 = (props: ILiteTradeSelectAccountToggleProps) => {
    const { variant, disabled, onClick, type } = props;
    const { getLangPath } = useLangContext();
    const isDemoAccount = type === ACCOUNT_TYPES.DEMO;

    return <SelectAccountToggle2Styled className={classNames({
        demo: isDemoAccount,
        'filled': variant === 'filled',
    })} onClick={onClick}>
        {isDemoAccount && <BinIcon name={'IcEducation'} size={24}/>}
        {!isDemoAccount && variant === 'filled' && <BinIcon name={'IcCoinStack'} size={24}/>}
        <span>{getLangPath(`lite_version.home.${isDemoAccount ? 'account_demo' : 'account_real'}`)}</span>
        {
            !disabled &&
            <div className={'chevron'}><BinIcon name={'IcChevronDown'} className={'text-secondary'} size={16}/></div>
        }
    </SelectAccountToggle2Styled>;
};


export default LiteTradeSelectAccountToggle2;

